import store from "../../../../redux/store";
import { setShareCutModalStatus, setShareModalStatus } from "../../../../redux/slices/fileManagerSlice";
import { handleClearAllSelectedResources, handleSetContextMenuStatus } from "../fileManager.actions";
import { syncFileManager } from "../fileManager.function";

const dispatch = store.dispatch;

export function handleSetShareModalStatus(status: boolean) {
    const fileManager = store.getState().fileManager;
    handleSetContextMenuStatus(false);
    dispatch(setShareModalStatus(status));
    if (!status && !fileManager.previewModalStatus) handleClearAllSelectedResources();
}

export function handleSetShareCutModalStatus(status: boolean) {
    const fileManager = store.getState().fileManager;
    dispatch(setShareCutModalStatus(status));
    handleSetContextMenuStatus(false);
    if (!status) syncFileManager(false);
    if (!status && !fileManager.previewModalStatus) handleClearAllSelectedResources();
}
